"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContainer = exports.createRowData = void 0;
var React = require("react");
var memoize = require("fast-memoize");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var classNames = require("classnames");
var sok_ui_1 = require("@caddigital/sok-ui");
var bidListActions = require("@caddigital/sok-reducers/lib/actions/bid/list");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translate_1 = require("utils/translate");
var Types = require("types");
var viewport_1 = require("reducers/viewport");
var search_1 = require("utils/search");
var utils_1 = require("./utils");
var NotFoundPlaceholder_1 = require("./NotFoundPlaceholder");
var filtering_1 = require("./filtering");
var sorting_1 = require("./sorting");
var Header_1 = require("./Header");
var ListRow_1 = require("./ListRow");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    var _a = state.bid.list, _b = _a.orderByOptions, orderBy = _b.orderBy, order = _b.order, searchString = _a.searchString, filterOptions = _a.filterOptions, offset = _a.offset, limit = _a.limit, list = _a.list;
    var data = (0, filtering_1.getFilteredData)(list, searchString, filterOptions).sort((0, sorting_1.sortBidList)(orderBy, order));
    var items = data.slice(Math.max(0, Math.min(data.length, offset)), Math.min(offset + limit, data.length));
    return {
        items: items,
        total: data.length,
        list: state.bid.list,
        isMobile: (0, viewport_1.isMobile)(state.viewport),
        selectedLanguage: selectedLanguage,
        user: state.auth.current.user
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (briefcase) {
        return dispatch(bidListActions.fetchRequest(briefcase));
    },
    setPaginationOptions: function (offset, limit) {
        return dispatch(bidListActions.setPaginationOptions(offset, limit));
    },
    setColumnFilter: function (field, value) {
        return dispatch(bidListActions.setColumnFilter(field, value));
    },
    setOrderBy: function (orderBy, order) {
        return dispatch(bidListActions.setOrderBy(orderBy, order));
    },
    toggleSelect: function (id) { return dispatch(bidListActions.toggleSelection(id)); },
    clear: function () { return dispatch(bidListActions.clear()); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
exports.createRowData = memoize(function (props) { return ({
    items: props.items,
    currentBriefcase: props.currentBriefcase,
    currentBid: props.currentBid,
    selectedLanguage: props.selectedLanguage,
    selected: props.list.selected,
    toggleSelect: props.toggleSelect
}); });
// This should probably be done with React's CSS facilities instead
var setDynamicStyles = function (lengths) {
    var style = document.getElementById('AdditionaLetterListCSS');
    if (style && style.parentNode) {
        style.parentNode.removeChild(style);
    }
    style = document.createElement('style');
    style.id = 'AdditionaLetterListCSS';
    document.head && document.head.appendChild(style);
    var sheet = style.sheet;
    Object.keys(lengths).forEach(function (className, i) {
        var colwidth = Math.max(8, 4 + lengths[className] + 26); // convert to rem
        sheet.insertRule(".".concat(className) +
            ' {max-width: ' +
            colwidth +
            'px;\n min-width: ' +
            colwidth +
            'px;}', i);
    });
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
var portalHeaders = ['id', 'name', 'description', 'publishedAt'];
var headers = ['status', 'updatedAt'];
var getHeaders = memoize(function (currentBriefcase) {
    return portalHeaders.concat(currentBriefcase ? headers : []);
});
exports.ListContainer = enhance(function (props) {
    var _a = props.list, status = _a.status, selected = _a.selected, orderByOptions = _a.orderByOptions, filterOptions = _a.filterOptions, limit = _a.limit, itemsPerPage = _a.itemsPerPage, offset = _a.offset, isMobile = props.isMobile, items = props.items, queryParams = props.queryParams, pathname = props.pathname, total = props.total, currentBid = props.currentBid, setOrderBy = props.setOrderBy, setColumnFilter = props.setColumnFilter, setPaginationOptions = props.setPaginationOptions, updateUrl = props.updateUrl, toggleSelect = props.toggleSelect, fetch = props.fetch;
    var lengths = (0, utils_1.getColumnWidths)(items, isMobile, getHeaders(props.currentBriefcase));
    setDynamicStyles(lengths);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "additional-letters-list-view-list-container" },
            React.createElement("div", { className: classNames('sok-list-content', 'additional-letters-list-view-list', status.toLowerCase()) },
                status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: "error", title: (0, translation_1.getLocalization)('generic/error') },
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () { return fetch(currentBid); } }))),
                (status === 'FETCHING' || status === 'STANDBY') && (React.createElement("div", { key: "loading", className: "loading" },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                status === 'FETCHED' && items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(sok_ui_1.List, { itemCount: items.length, itemData: (0, exports.createRowData)(props), overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: (0, utils_1.getContentWidth)(lengths), header: React.createElement(Header_1.default, { currentBriefcase: props.currentBriefcase, orderByOptions: orderByOptions, filterOptions: filterOptions, setOrderBy: setOrderBy, updateUrl: updateUrl, queryParams: queryParams, pathname: pathname, setColumnFilter: setColumnFilter, toggleSelect: toggleSelect, items: items, selected: selected }), placeholder: React.createElement(NotFoundPlaceholder_1.default, null) }, ListRow_1.default));
                })))),
        React.createElement(sok_ui_1.Pagination, { key: "pagination", limit: limit, total: total, limitOptions: itemsPerPage, offset: offset, updatePageState: function (offset, limit) {
                setPaginationOptions(offset, limit);
                updateUrl(pathname + (0, search_1.getQueryParams)(__assign(__assign({}, queryParams), { offset: offset, limit: limit })));
            } })));
});
